import { connect } from 'react-redux';
import React, { Component } from 'react';
import routerActions from 'app/routerActions';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import * as valid from 'utils/validate';
import { api, apiUtils } from 'app/services';
import classNames from 'classnames';
import { KBLoadingContainer } from 'components';
import { canAccessSpaceRoles } from 'app/reducers/role';
import * as selectors from 'app/selectors';
import { util, isHideModule } from 'utils/kbUtil';
import _ from 'lodash';

const DEFAULT_TOP_MENU = [
{
  name: 'CRM统计',
  value: 'crm',
  roles: ['crm'] },

{
  name: '工位统计',
  value: '',
  roles: ['location_manager'] },

{
  name: '会员统计',
  value: 'organization',
  roles: ['location_manager'] },

{
  name: '会议室统计',
  value: 'meeting',
  roles: ['location_manager'] },

{
  name: '报修统计',
  value: 'task',
  roles: ['location_manager'] },

{
  name: '收款统计',
  value: 'invoice',
  roles: ['location_manager'] },

{
  name: '开门统计',
  value: 'lock',
  roles: ['location_manager'] }];



const HIDE_MODULE = [
{
  name: 'CRM统计',
  value: 'crm',
  roles: ['crm'] },

{
  name: '报修统计',
  value: 'task',
  roles: ['location_manager'] }];



var SpaceStatisticBox = class extends React.Component {render()
  {
    const { section, group_id, space_id, user } = this.props;

    let menu = DEFAULT_TOP_MENU;
    const canShowCrmStatistic = canAccessSpaceRoles(user, ['statistic']);
    const hideModule = isHideModule(space_id);

    if (!canShowCrmStatistic) {
      menu = menu.filter(n => n.value !== 'crm');
    }

    if (hideModule) {
      menu = _.differenceWith(menu, HIDE_MODULE, _.isEqual);
    }

    let pathname = `/admin/groups/${group_id}/statistic`;
    // if (group_id) {
    //   pathname = `/admin/locations/${location_id}/statistic`
    // }
    const childrenWithProps = React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        group_id });

    });
    return (
      <section className="kb-content">
        <nav className="nav-container f-left">
          <div className="nav-container-content">
            <header className="nav-header clear-fix">
              <h2 className="header-title f-left">统计报表</h2>
            </header>
            <div className="nav-body">
              <ul className="nav-container-list">
                {menu.map((data, index) => {
                  return (
                    <li
                    key={index}
                    className={
                    section == data.value ?
                    'nav-container-list-hover' :
                    ''}>


                      <Link to={`${pathname}/${data.value}`}>
                        {' '}
                        {data.name}{' '}
                      </Link>
                    </li>);

                })}
              </ul>
            </div>
          </div>
        </nav>
        {childrenWithProps}
      </section>);

  }};


function mapStateToProps(state, props) {
  const { user } = state;
  const {
    params,
    location,
    params: { id } } =
  props;
  let sections = location.pathname.split('/');
  let statisticIndex = sections.indexOf('statistic');
  let section = statisticIndex > -1 ? sections[statisticIndex + 1] : '';
  let space_id = Object.keys(state.entities.spaces || {})[0];
  let group_id = id;
  // const group = selectors.getCurrentGroup(state, location_id)
  return {
    user,
    space_id,
    section: section || '',
    // location_id,
    group_id };

}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(SpaceStatisticBox);
